/**
 * @generated SignedSource<<b6470ae23ca0a55d8d1c301607de1d05>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ResultFilter = {
  matchAny?: boolean | null | undefined;
  metaKey: string;
  metaValues: ReadonlyArray<string>;
};
export type RespondentFilterUsingMetaResultsQuery$variables = {
  filters?: ReadonlyArray<ResultFilter> | null | undefined;
  questionnaireId: string;
};
export type RespondentFilterUsingMetaResultsQuery$data = {
  readonly metaResults: ReadonlyArray<{
    readonly metaKey: string | null | undefined;
    readonly metaValue: string | null | undefined;
    readonly responseCount: number | null | undefined;
  }>;
};
export type RespondentFilterUsingMetaResultsQuery = {
  response: RespondentFilterUsingMetaResultsQuery$data;
  variables: RespondentFilterUsingMetaResultsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filters"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "questionnaireId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "filters",
    "variableName": "filters"
  },
  {
    "kind": "Variable",
    "name": "questionnaireId",
    "variableName": "questionnaireId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "metaValue",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "metaKey",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "responseCount",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "RespondentFilterUsingMetaResultsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "MetaResult",
        "kind": "LinkedField",
        "name": "metaResults",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "RespondentFilterUsingMetaResultsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "MetaResult",
        "kind": "LinkedField",
        "name": "metaResults",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "bd42f3296e2ca4540bfafa8c27b7bbe0",
    "id": null,
    "metadata": {},
    "name": "RespondentFilterUsingMetaResultsQuery",
    "operationKind": "query",
    "text": "query RespondentFilterUsingMetaResultsQuery(\n  $questionnaireId: ID!\n  $filters: [ResultFilter!]\n) {\n  metaResults(questionnaireId: $questionnaireId, filters: $filters) {\n    metaValue\n    metaKey\n    responseCount\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "ca9d0c06a3d1236854ba87430812e6f0";

export default node;
